import type { Area } from "./me";

const AREA_PREFIX: Record<Area, string> = { seller: "/app", owner: "/portal" };
/** Loop guard (FE-01 §8): never send someone back to a login or auth route. */
const BLOCKED = ["/app/login", "/app/register", "/portal/login", "/auth/"];

/**
 * Open-redirect protection (FE-01 FR-FE01-05): keep `value` only when it is a same-origin relative
 * path (with search) inside `area`; otherwise return null so the caller uses the area home.
 */
export function safeRedirect(value: unknown, area: Area): string | null {
  if (typeof value !== "string" || value.length > 2000) return null;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  let url: URL;
  try {
    url = new URL(value, "http://sos.invalid");
  } catch {
    return null;
  }
  if (url.origin !== "http://sos.invalid") return null;
  const prefix = AREA_PREFIX[area];
  const path = url.pathname;
  if (path !== prefix && !path.startsWith(`${prefix}/`)) return null;
  if (BLOCKED.some((b) => path === b || path.startsWith(b.endsWith("/") ? b : `${b}/`))) {
    return null;
  }
  return `${url.pathname}${url.search}`;
}

export function areaHome(area: Area): "/app" | "/portal" {
  return area === "owner" ? "/portal" : "/app";
}
